import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=bf2a1acc&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=bf2a1acc&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=2&id=bf2a1acc&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf2a1acc"]])

export default __exports__